$(window).on('load', function() {
  if(window.upcartSubscribeCartUpdated != undefined){
    window.upcartSubscribeCartUpdated(({ cart }) => {
      fetch('/cart.js', {
          method: 'GET',
          cache: 'no-store'
        })
        .then(response => response.json())
        .then(cart => {
          if (cart.item_count > 0) {
            let enable_shipping = sessionStorage.getItem('enable_shipping');
            if (!enable_shipping) {
              const shadowHost = document.querySelector('#upCart');
              if (shadowHost && shadowHost.shadowRoot) {
                const cart_popup = shadowHost.shadowRoot.querySelector('#UpcartPopup');
                if (cart_popup) {
                  const shipping_switch = cart_popup.querySelector('.upcart-footer .upcart-addons .upcart-addons-toggle .styles_ToggleSwitch__');
                  if (shipping_switch) {
                    shipping_switch.click();
                    sessionStorage.setItem('enable_shipping', 'yes');
                  }
                }
              } else {
                console.error('Shadow root not found');
              }
            }
          }
        })
        .catch(error => console.error('Error:', error));
    }); 
  }
});



$(document).ready(function() {

  // $(document).on('click', '.quantity__button', function() {

  //   var $quantityInput = $(this).siblings('.quantity__input');
  //   var currentQuantity = parseInt($quantityInput.val());
  //       var newQuantity = $(this).attr('name') === 'plus' ? currentQuantity + 1 : Math.max(currentQuantity - 1, 0);
  //       $quantityInput.val(newQuantity);
  //       updateCartItemQuantity($quantityInput.data('quantity-variant-id'), newQuantity);
  // });


  // function updateCartItemQuantity(variantId, quantity) {
  //       // Define the UpCart API URL for updating the item
  //       var url = '/cart/change.js'; // Update the URL based on UpCart API documentation

  //       // Make an API request to update the cart item
  //       $.ajax({
  //           url: url,
  //           type: 'POST',
  //           dataType: 'json',
  //           data: {
  //               id: variantId,
  //               quantity: quantity
  //           },
  //           success: function(response) {
  //               console.log('Cart item updated successfully:', response);
  //               // Refresh the cart with UpCart API
  //               window.upcartRefreshCart();
  //           },
  //           error: function(xhr, status, error) {
  //               console.error('Error updating cart item:', status, error);
  //           }
  //       });
  //   }

  
  // var freeProductVariantId = 47892200390861;
  //     function getCartData() {
  //       $.ajax({
  //           url: '/cart.js', 
  //           type: 'GET',
  //           dataType: 'json',
  //           success: function(cart) {

  //             var cart_total_price = formatPrice(cart.total_price);

  //              var freeProductInCart = false;

  //               cart.items.forEach(function(item) {
  //                   if (item.variant_id == freeProductVariantId) {
  //                       freeProductInCart = true;
  //                   }
  //               });

  //             if ((cart_total_price >= "$70" || cart_total_price <= "$70") && !freeProductInCart) 
  //             {
  //                   if (!freeProductInCart) 
  //                   {
  //                      location.reload(true);

  //                   }
  //               }
  //               else 
  //               {
  //                   if (freeProductInCart) 
  //                   {
  //                       $('.cart_items_product[cart-var-id="'+freeProductVariantId+'"]').hide();
  //                       removeFreeProduct(freeProductVariantId);
  //                   }
  //               }
              
  //           },
  //           error: function(xhr, status, error) {
  //               console.error('Error fetching cart data:', error);
  //           }
  //       });
  //   }

  //   function formatPrice(price) {
  //       var formattedPrice = Shopify.formatMoney(price, Shopify.money_format);
  //       return formattedPrice;
  //   }

  

  

  
  //   function removeFreeProduct(variantId) {
  //       $.ajax({
  //           url: '/cart/change.js',
  //           type: 'POST',
  //           dataType: 'json',
  //           data: {
  //               id: variantId,
  //               quantity: 0 
  //           },
  //           success: function (cart) {
  //               console.log('Free product removed successfully:', cart);
  //           },
  //           error: function (xhr, status, error) {
  //               console.error('Error removing free product:', error);
  //           }
  //       });
  //   }
   
  //      $(document).on('click', '.quantity__button', function() {

  //          $('.cart_items_product').show();
  //           if ($(this).attr('name') === 'minus') 
  //           {
  //             setTimeout(function() {
  //                   getCartData();
  //             }, 3000);
  //           } 
  //           else if ($(this).attr('name') === 'plus') 
  //           {
  //               setTimeout(function() {
  //                   getCartData();
  //             }, 3000);
  //           }
  //       });
});

  
  // $('.cart-item__name').each(function() {
  //       // Check if the text of the current element matches "Free Magnetic Wristband"
  //       if ($(this).text().trim() === "Free Magnetic Wristband") {
  //         var quantityElement = $(this).parent().siblings('.cart-item__quantity').text('1');
  //         console.log("Found element with text: Free Magnetic Wristband");
  //       }
  // });


// document.querySelectorAll('.quantity__button').forEach(function(button) {
//   button.addEventListener('click', function() {
//       window.upcartRefreshCart();
//       window.upcartOnCartUpdated();
//       console.log("clicked");
//   });
// });
// document.addEventListener('DOMContentLoaded', function() {
//     // Function to check the cart total and remove free gift if necessary
//     function checkCartTotal() {
//         fetch('/cart/change.js?upcart=1') // Adjust endpoint based on UpCart API
//             .then(response => response.json())
//             .then(cart => {
//                 var freeGiftProductId = '8926171791565'; // Free gift product ID
//                 var cartTotal = cart.total / 100; // Assuming cart.total is in cents

//                 if (cartTotal < 70) {
//                     var freeGiftItem = cart.items.find(item => item.product_id === freeGiftProductId);

//                     if (freeGiftItem) {
//                         // Remove the free gift item
//                         fetch('/upcart/api/cart/update', { // Adjust endpoint based on UpCart API
//                             method: 'POST',
//                             headers: {
//                                 'Content-Type': 'application/json',
//                             },
//                             body: JSON.stringify({
//                                 line: freeGiftItem.key, // Ensure this is correct based on UpCart's API
//                                 quantity: 0
//                             })
//                         })
//                         .then(response => response.json())
//                         .then(() => location.reload()); // Reload to reflect the changes
//                     }
//                 }
//             });
//     }

//     // Attach the checkCartTotal function to quantity button clicks
//     document.querySelectorAll('.quantity__button').forEach(function(button) {
//         button.addEventListener('click', function() {
//             window.upcartOnCartUpdated();
//             // setTimeout(checkCartTotal, 500); // Delay to ensure cart is updated
//         });
//     });
// });


// function updateRowVisibility() {
//   var totalValueElement = document.querySelector('.totals__total-value');
//   var totalValue = parseFloat(totalValueElement.textContent.replace(/[^\d.]/g, ''));
//   var aTags = document.querySelectorAll('a');
//   aTags.forEach(function(aTag) {
//     if (aTag.textContent.includes('Free Magnetic Wristband')) {
//       var parentTr = aTag.closest('tr');
//       if (totalValue < 70) {
//         parentTr.style.display = 'none';
//       } else {
//         parentTr.style.display = ''
//       }
//     }
//   });
// }

// var totalValueElement = document.querySelector('.totals__total-value');
// var observer = new MutationObserver(function(mutations) {
//   mutations.forEach(function(mutation) {
//     if (mutation.type === 'characterData' || mutation.type === 'childList') {
//       updateRowVisibility();
//     }
//   });
// });
// observer.observe(totalValueElement, {
//   characterData: true,
//   subtree: true,
//   childList: true
// });
// updateRowVisibility();


